import { render, staticRenderFns } from "./RoomRecord.vue?vue&type=template&id=db3a5f66&"
import script from "./RoomRecord.vue?vue&type=script&lang=js&"
export * from "./RoomRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db3a5f66')) {
      api.createRecord('db3a5f66', component.options)
    } else {
      api.reload('db3a5f66', component.options)
    }
    module.hot.accept("./RoomRecord.vue?vue&type=template&id=db3a5f66&", function () {
      api.rerender('db3a5f66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/ExtendMenu/RoomRecord/RoomRecord.vue"
export default component.exports